module.exports = __webpack_public_path__ + "static/img/tp_empty.0c42e6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tp_empty.png
// module id = F7hp
// module chunks = 10